import { Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'

type Props = {
  title: string
  headerActions: ReactNode
}

export const StickyHeader = ({ title, headerActions }: Props) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      boxShadow={1}
      sx={{
        position: 'sticky',
        top: -16,
        width: '100%',
        background: '#fff',
        p: 1.5,
        zIndex: 2,
      }}
    >
      <Typography>{title}</Typography>
      {headerActions}
    </Stack>
  )
}
